"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    listContainer: {
      "& > .MuiDivider-root": _defineProperty({
        marginRight: theme.spacing(2.5),
        marginLeft: theme.spacing(2.5)
      }, theme.breakpoints.down("xs"), {
        marginRight: theme.spacing(2),
        marginLeft: theme.spacing(2)
      })
    }
  };
});
/**
 * ** Lists are continuous, vertical indexes of text or images. **
 *
 * There are 3 ways in which lists can be grouped:
 *
 * - Card - Individual
 *
 * - Card - Group
 *
 * - Card - Background
 */

var ListContainer = function ListContainer(_ref) {
  var children = _ref.children;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.List, {
    className: styles.listContainer,
    component: "div",
    disablePadding: true
  }, children);
};

ListContainer.propTypes = {
  /** The children elements of the list */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node])
};
ListContainer.defaultProps = {
  children: null
};
var _default = ListContainer;
exports.default = _default;